import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import Button from '~/components/Button'
import { PageContent } from '~/components/PageContent'
import { useBreadcrumbs } from '~/hooks/useBreadcrumbs'

export const SettingsPage = () => {
  const breadCrumbs = useBreadcrumbs()
  const navigate = useNavigate()
  const location = useLocation()
  const isOnHomePage = location.pathname.endsWith('settings')
  return (
    <PageContent
      breadcrumbs={breadCrumbs}
      headerActions={
        !isOnHomePage && (
          <Button onClick={() => navigate(-1)} variant={'tertiary'} trackingLabel={'common-settings-back'}>
            Back
          </Button>
        )
      }
    >
      <Outlet />
    </PageContent>
  )
}
